import { render } from "./RecipientsBlacklistForm.vue?vue&type=template&id=8b654c26"
import script from "./RecipientsBlacklistForm.vue?vue&type=script&lang=js"
export * from "./RecipientsBlacklistForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__